import React from 'react';
import { Star } from 'lucide-react';

// Content-only interstitial screen (Batch 2b-i). No input — a single Continue
// button. Visually distinct from question screens (centered card + imagery).
export default function SplashScreen({ splash, brandColor = '#1c1917', buttonColor = '#1c1917', onContinue }) {
    const s = splash || {};
    const t = s.testimonial;
    return (
        <div className="text-center">
            {s.image_url && (
                <img src={s.image_url} alt="" className="mx-auto mb-6 max-h-48 rounded-2xl object-cover" />
            )}
            {s.headline && (
                <h1 className="text-3xl font-bold text-stone-900 mb-3" style={{ fontFamily: 'Manrope, sans-serif' }}>{s.headline}</h1>
            )}
            {s.body && <p className="text-base text-stone-600 leading-relaxed mb-6 whitespace-pre-wrap">{s.body}</p>}

            {t && (t.quote || t.author) && (
                <div className="bg-white border border-stone-200 rounded-2xl p-5 mb-6 text-left shadow-sm">
                    {typeof t.rating === 'number' && t.rating > 0 && (
                        <div className="flex gap-0.5 mb-2">
                            {Array.from({ length: 5 }, (_, i) => (
                                <Star key={i} className="w-4 h-4" style={{ color: i < t.rating ? brandColor : '#e7e5e4' }}
                                    fill={i < t.rating ? brandColor : 'none'} />
                            ))}
                        </div>
                    )}
                    {t.quote && <p className="text-stone-700 italic mb-2">“{t.quote}”</p>}
                    {(t.author || t.role) && (
                        <p className="text-xs text-stone-500">
                            {t.author}{t.author && t.role ? ' · ' : ''}{t.role}
                        </p>
                    )}
                </div>
            )}

            <button type="button" onClick={onContinue}
                className="w-full px-6 py-3.5 rounded-xl text-white font-medium text-base min-h-[52px]"
                style={{ backgroundColor: buttonColor }}>
                {s.button_label || 'Continue'}
            </button>
        </div>
    );
}
